<template>
    <div>
      <a-card class="c_annualPlafon">
        <div slot="title" class="m-display-flex space-between custom">
          <span class="cmain-title"><a-icon type="project" />&nbsp;Annual Target</span>
          <a-button v-if="show_choose_pipeline" type="primary" class="cbtn-create" icon ="plus" @click="showModalCreate">Create</a-button>
        </div>
        <a-card>
          <div class="m-display-flex space-between align-middle">
            <div :class="getScreen?'m-width-full':'m-display-flex'">
              <div :style="getScreen?'width:100%;':''" :class="getScreen?'margin-top':''">
                &nbsp;Type :&nbsp;
                <a-select
                  placeholder="Choose"
                  v-model="selected.type"
                  @change="changeType"
                  :filterOption="filterOption"
                  showSearch
                  :style="getScreen?'':'width:180px'"
                  :class="getScreen?'m-width-full':''"
                  :disabled="loading.page"
                >
                  <a-select-option v-for="item in typeList" :key="item.value" :value="item.value">{{ item.label }}</a-select-option>
                </a-select>
              </div>
              <div :style="getScreen?'width:100%':''">
                &nbsp;Year :&nbsp;<a-select
                  placeholder="Choose"
                  v-model="selected.year"
                  @change="changeYear"
                  :filterOption="filterOption"
                  showSearch
                  :style="getScreen?'':'width:100px'"
                  :class="getScreen?'m-width-full':''"
                  :disabled="loading.page"
                >
                  <a-select-option v-for="item in year" :key="item" :value="item">{{ item }}</a-select-option>
                </a-select>
              </div>
              <div :style="getScreen?'width:100%;':''" :class="getScreen?'margin-top':''">
                &nbsp;Version :&nbsp;<a-select
                  placeholder="Choose"
                  v-model="selected.version"
                  @change="changeVersion"
                  :filterOption="filterOption"
                  showSearch
                  :style="getScreen?'':'width:180px'"
                  :class="getScreen?'m-width-full':''"
                  :disabled="loading.page"
                >
                  <a-select-option v-for="item in version" :key="item.value" :value="item.value">{{ item.label }}</a-select-option>
                </a-select>
              </div>
              <a-button :style="'margin-left: 10px'" type="primary" icon ="file" :loading="loading_view" @click="viewModalAnnualTarget">View</a-button>
            </div>
            <a-button v-if="!getScreen" type="secondary" icon="reload" @click="refreshData">Refresh</a-button>
          </div>
        </a-card>

        <a-row :gutter="8">
          <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
            <a-collapse v-model="activeKey.header" :activeKey="activeKey.header"
            :class="getScreen?'margin-top':''"
            >
              <a-collapse-panel key="1">
                <span slot="header">
                  <div class="m-display-flex space-between align-middle">
                    <div v-if="!getScreen">
                      Type : {{ view.type ? view.type : "-" }}
                      &nbsp;&nbsp;&nbsp;Year : {{ view.year ? view.year : "-" }}
                      &nbsp;&nbsp;&nbsp;Version : {{ view.version ? view.version : "-" }}
                    </div>
                    <div v-else>
                      {{ view.type ? view.type : "-" }} : 
                      {{ view.year ? view.year : "-" }} : 
                      {{ view.version ? view.version : "-" }}
                    </div>
                  </div>
                </span>

                <div class="margin-bottom" >
                  <a-row :gutter="8">

                    <a-col :span="6">
                      <a-card title="TARGET PROJECT VALUE" size="small">
                        <div class="text-center">
                          <a-row :gutter="2">
                            <a-col :span="10">
                              <div class="text-secondary">Planning</div>
                              <strong>{{ formatCurrency('IDR', target_value.planning) }}</strong>

                              <div class="text-secondary">Actual</div>
                              <strong>{{ formatCurrency('IDR', target_value.actual) }}</strong>
                            </a-col>
                            <a-col :span="14" class="chart-container">
                              <a-progress
                                class="progress-big-text"
                                type="circle"
                                :stroke-width="13"
                                :percent="realization(target_value.planning, target_value.actual)"
                                :format="percent => `${realization(target_value.planning, target_value.actual)}%`"
                              />
                              <!-- <a-progress
                                type="circle"
                                :percent="Math.min(realization(ebt.planning, ebt.actual), 100)"
                                :format="percent => `${calculateMargin(ebt.planning, ebt.actual)}`"
                              /> -->
                            </a-col>
                          </a-row>

                          <div style="margin-top: 5px">
                            <strong>{{ calculateMargin(target_value.planning, target_value.actual, 'nominal') }}</strong>
                          </div>
                        </div>
                      </a-card>
                    </a-col>

                    <a-col :span="6">
                      <a-card title="OVERHEAD" size="small">
                        <div class="text-center">
                          <a-row :gutter="2">
                            <a-col :span="10" >
                              <div class="text-secondary">Planning</div>
                              <strong>{{ formatCurrency('IDR', overhead.planning) }}</strong>
                              
                              <div class="text-secondary">Actual</div>
                              <strong>{{ formatCurrency('IDR', overhead.actual) }}</strong>
                            </a-col>
                            <a-col :span="14" class="chart-container">
                              <a-progress
                                class="progress-big-text"
                                type="circle"
                                :stroke-width="13"
                                :stroke-color="overhead.actual > overhead.planning ? '#e01b1d' : '#87D068'"
                                :percent="Math.min(realization(overhead.planning, overhead.actual), 100)"
                                :format="percent => `${realization(overhead.planning, overhead.actual)}%`"
                              />
                            </a-col>
                          </a-row>
                          <div style="margin-top: 5px">
                            <strong>{{ calculateMargin(overhead.planning, overhead.actual, 'idr') }}</strong>
                          </div>
                        </div>
                      </a-card> 
                    </a-col>
                    
                    <a-col :span="6">
                      <a-card title="DEPRECIATION" size="small">
                        <div class="text-center">
                          <a-row :gutter="2">
                            <a-col :span="10" >
                              <div class="text-secondary">Planning</div>
                              <strong> {{ formatCurrency('IDR', depreciation.planning) }}</strong>

                              <div class="text-secondary">Actual</div>
                              <strong> {{ formatCurrency('IDR', depreciation.actual) }}</strong>
                            </a-col>
                            <a-col :span="14" class="chart-container">
                              <a-progress
                                class="progress-big-text"
                                type="circle"
                                :stroke-width="13"
                                :stroke-color="depreciation.actual > depreciation.planning ? '#e01b1d' : '#87D068'"
                                :percent="Math.min(realization(depreciation.planning, depreciation.actual), 100)"
                                :format="percent => `${realization(depreciation.planning, depreciation.actual)}%`"
                              />
                            </a-col>
                          </a-row>

                          <div style="margin-top: 5px">
                            <strong>{{ calculateMargin(depreciation.planning, depreciation.actual, 'idr') }}</strong>
                          </div>
                        </div>
                      </a-card>
                    </a-col>
                    
                    <a-col :span="6">
                      <a-card title="EBT" size="small">
                        <div class="text-center">
                          <a-row :gutter="2">
                            <a-col :span="12">
                              <div class="text-secondary">Planning</div>
                              <!-- <strong>{{ ebt.planning }}%</strong> -->
                              <span><strong>{{ ebt.planning }}%</strong> / {{ formatCurrency('IDR', calculateEbtValue) }}</span>

                              <div class="text-secondary">Actual</div>
                              <span><strong>{{ ebt.actual }}%</strong> / {{ formatCurrency('IDR', ebt.pa_value) }}</span>
                            </a-col>
                            <a-col :span="12" class="chart-container">
                              <a-progress
                                class="progress-big-text"
                                type="circle"
                                :stroke-width="13"
                                :percent="Math.min(realization(ebt.planning, ebt.actual), 100)"
                                :format="percent => `${realization(ebt.planning, ebt.actual)}%`"
                              />
                              <!-- <a-progress
                                type="circle"
                                :percent="Math.min(realization(ebt.planning, ebt.actual), 100)"
                                :format="percent => `${calculateMargin(ebt.planning, ebt.actual)}`"
                              /> -->
                            </a-col>
                          </a-row>

                          <div style="margin-top: 5px">
                            <strong>{{ calculateMargin(ebt.planning, ebt.actual) }}</strong>
                          </div>
                        </div>
                      </a-card>
                    </a-col>
                  </a-row> 
                </div>

                <a-card size="small" class="custom-card" title="Financial Breakdown" style="width: 100%;">
                  <template #extra>
                    <!-- <span style="padding-right: 10px;">Values in IDR (Jutaan)</span> -->
                    <a-tag color="default" style="padding-right: 10px; color: black;">Values in IDR ({{ isBillion ? 'Miliar' : 'Juta' }})</a-tag>
                    <a-switch
                      v-model="isBillion"
                    >
                      <template slot="checkedChildren">
                        Miliar
                      </template>

                      <template slot="unCheckedChildren">
                        Juta
                      </template>
                    </a-switch>
                    {{ show_choose_pipeline ? "|" : ""}}
                    <a-button v-if="show_choose_pipeline" :disabled="isEnabled" type="primary" :loading="loading_pipeline" @click="fetchListPipeline()">Choose {{view.type}}</a-button>
                    |
                    <a-tooltip title="Simulation">
                      <a-button :disabled="enabledSimulation" :loading="loading_simulation" icon="control" type="primary" @click="showModalSimulation()"></a-button>
                    </a-tooltip>
                  </template>
                  <a-table 
                    size="small"
                    rowKey="key"
                    :columns="columns" 
                    :data-source="data_table"
                    :loading="loading"
                    :pagination="false"
                    :rowClassName="rowClassName"
                    @expand="onExpand"
                    class="custom-table"
                    bordered>
                    <template slot="component" slot-scope="text, item">
                      <strong v-if="item.component" :class="item.component == 'Ebitda' || item.component == 'Ebt' ? 'single-parent' : ''">
                        {{ item.component }}
                      </strong>

                      <span v-else>
                        {{ 
                          '- ' + item.nomor + ' - ' + item.definitions +
                          (item.status && item.progress !== null && item.progress !== undefined
                            ? ` - (${item.status}) - ${item.progress} %`
                            : '')
                        }}
                      </span>
                    </template>
                    <template slot="value" slot-scope="text, item, index">
                      {{ customFormatCurrency('IDR', isBillion ? item.value/1000 : item.value) }}
                    </template>
                    <template slot="revenue" slot-scope="text, item, index">
                      {{ item.revenue + ' %' }}
                    </template>
                  </a-table>
                </a-card>
                
              </a-collapse-panel>
            </a-collapse>
          </a-col>
        </a-row>
      </a-card>

      <!-- <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
        <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
          <a-card>
            <div slot="title"><a-icon type="file-search" />&nbsp;Search</div>
            <ul class="m-list-wrapper">
              <li>
                <a-input-search v-model="search" :disabled="triggerSearch" placeholder="Quick Search" />
              </li>
              <li>
                <a-collapse :activeKey="getScreen ? 0 : 1">
                  <a-collapse-panel key="1">
                    <span slot="header">Search More...</span>
                    <div class="m-form-item-wrapper">
                      <label for="tanggalTransaksi">Transaction Date</label>
                      <a-date-picker placeholder="Select Date" v-model="searchDate" :disabled="triggerSearch"
                        :format="getDefaultDateFormat" allowClear />
                    </div>
      
                    <div class="m-form-item-wrapper">
                      <label for="director">Director</label>
                      <a-select placeholder="Choose director" v-model="director" :disabled="triggerSearch" class="width-full"
                        initialValue="undefined" allowClear>
                        <a-select-option v-for="item in listDirector" :key="item.value" :value="item.value">{{ item.text
                        }}</a-select-option>
                      </a-select>
                    </div>
      
                    <div class="m-form-item-wrapper">
                      <label for="tanggalTransaksi">Status</label>
                      <a-select placeholder="Ex: Approved ... " v-model="status" :disabled="triggerSearch" class="width-full"
                        initialValue="delivered" allowClear>
                        <a-select-option v-for="item in getStatus" :key="item.id" :value="item.value">{{ item.label
                        }}</a-select-option>
                      </a-select>
                    </div>
                  </a-collapse-panel>
                </a-collapse>
              </li>
            </ul>
          </a-card>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
          <DataList  
              title="Annual Target List" 
              :isCustom="true"
              :dataList="searching"
              :loading="loading" 
              :price="true"
              createLink="create_klaim_tiket"
              :disabledCreateEditLink="false"
          >
              <template #extra>
                  <a-button icon="plus" type="primary" @click="showModalCreate">
                      Create
                  </a-button>
              </template>
      
              <template #content="{ items, paginate }">
                  <a-list itemLayout="vertical" :dataSource="items" :pagination="paginate">
                      <Empty v-if="dataList ? dataList.length <= 0 : dataList" />
                      <a-list-item slot="renderItem" slot-scope="item">
                          <a-list-item-meta>
                          <a-row slot="title" type="flex" justify="space-between">
                              <div>
                                  <h4 class="margin-remove">{{ item.no_target }}</h4>
                                  <small>{{ item.subtitle }}</small>
                              </div>
                              <Status :status="item.active_sts == '1' ? 'Active' : 'Non Active'" :class="getScreen ? 'margin-remove' : 'margin-left'" type="primary"/>
                          </a-row>
                          <div slot="description" class="margin-top">
                              <ul class="m-list-wrapper">
                                  <li class="margin-remove">
                                      <span>{{ item.create_dt }} | {{ item.tlc_create }}</span>
                                  </li>
                                  <li class="margin-remove">
                                      <h4>Overhead : {{ formatCurrency('IDR', item.overhead) }}</h4>
                                  </li>
                                  <li class="margin-remove">
                                      <h4>Depresiasi : {{ formatCurrency('IDR', item.depresiasi) }}</h4>
                                  </li>
                                  <li class="margin-remove">
                                      <h4>EBT : {{ item.ebt + '%' }}</h4>
                                  </li>
                                  <li>
                                      <h4>Catatan : {{ item.remark ? item.remark : '-'}}</h4>
                                  </li>
                              </ul>
                          </div>
                          </a-list-item-meta>
                          <template #action></template>
                      </a-list-item>
                      </a-list>
              </template>
      
          </DataList>
        </a-col>
      
      </a-row> -->

      <a-modal :visible="modal_create" @cancel="modalOnClose" :footer="null" :maskClosable="false" width="50%">
        <span slot="title">
          <span v-if="mode_view">
            <a-icon type="file" /> View Annual Target
          </span>
          <span v-else>
            <a-icon type="plus" /> Create Annual Target
          </span>
        </span>
      
        <a-form :form="form_create">
          <a-row :gutter="16">
            <a-col :span="12">
              <a-form-item label="Tahun - Target Project Value">
                <a-select
                placeholder=""
                :filterOption="filterOption"
                showSearch
                :class="getScreen?'m-width-full':''"
                v-decorator="['year', { 
                  initialValue: view_data.year,
                  rules: [{ required: true, message: 'Tahun wajib diisi' }] } ]"
                :disabled="mode_view"
                >
                  <a-select-option v-for="item in rups_option" :key="item.tahun" :value="item.tahun">{{ item.tahun +' - '+ customFormatCurrency('IDR', item.nilai_kontrak) }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="Overhead">
                <a-input-number type="number" class="m-width-full m-text-align-right"
                  v-on:keydown.enter.prevent="preventEnterButton" 
                  :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="value => value.replace(/\$\s?|(,*)/g, '')" 
                  v-decorator="['overhead',{ 
                    initialValue: view_data.overhead,
                    rules: [{ required: true }] 
                  },]" 
                  :disabled="mode_view"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="Depresiasi">
                <a-input-number type="number" class="m-width-full m-text-align-right"
                  v-on:keydown.enter.prevent="preventEnterButton" 
                  :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="value => value.replace(/\$\s?|(,*)/g, '')" 
                  v-decorator="['depresiasi',{ 
                    initialValue: view_data.depresiasi,
                    rules: [{ required: true }] 
                  },]" 
                  :disabled="mode_view"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="EBT">
                <a-input-number type="number" class="m-width-full m-text-align-right"
                :min="0"
                :max="100"
                :formatter="value => `${value}%`"
                :parser="value => value.replace('%', '')" 
                v-decorator="[
                  'ebt', { 
                    initialValue: view_data.ebt,
                    rules: [{ required: true }]
                },]" 
                :disabled="mode_view"
              />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="Biaya Penjualan">
                <a-input-number type="number" class="m-width-full m-text-align-right"
                  v-on:keydown.enter.prevent="preventEnterButton" 
                  :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="value => value.replace(/\$\s?|(,*)/g, '')" 
                  v-decorator="['biaya_penjualan',{
                    initialValue: view_data.biaya_penjualan,
                    rules: [{ required: true }] 
                  },]" 
                  :disabled="mode_view"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="Biaya Administrasi dan Umum">
                <a-input-number type="number" class="m-width-full m-text-align-right"
                  v-on:keydown.enter.prevent="preventEnterButton" 
                  :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="value => value.replace(/\$\s?|(,*)/g, '')" 
                  v-decorator="['biaya_admin_umum',{ 
                    initialValue: view_data.biaya_admin_umum,
                    rules: [{ required: true }] 
                  },]" 
                  :disabled="mode_view"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="Beban penyusutan">
                <a-input-number type="number" class="m-width-full m-text-align-right"
                  v-on:keydown.enter.prevent="preventEnterButton" 
                  :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="value => value.replace(/\$\s?|(,*)/g, '')" 
                  v-decorator="['beban_penyusutan',{ 
                    initialValue: view_data.beban_penyusutan,
                    rules: [{ required: true }] 
                  },]" 
                  :disabled="mode_view"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="Beban Amortisasi">
                <a-input-number type="number" class="m-width-full m-text-align-right"
                  v-on:keydown.enter.prevent="preventEnterButton" 
                  :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="value => value.replace(/\$\s?|(,*)/g, '')" 
                  v-decorator="['beban_amortisasi',{ 
                    initialValue: view_data.beban_amortisasi,
                    rules: [{ required: true }] 
                  },]" 
                  :disabled="mode_view"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="Beban Modal">
                <a-input-number type="number" class="m-width-full m-text-align-right"
                  v-on:keydown.enter.prevent="preventEnterButton" 
                  :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="value => value.replace(/\$\s?|(,*)/g, '')" 
                  v-decorator="['beban_modal',{ 
                    initialValue: view_data.beban_modal,
                    rules: [{ required: true }] 
                  },]" 
                  :disabled="mode_view"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="Pendapatan Lainnya">
                <a-input-number type="number" class="m-width-full m-text-align-right"
                  v-on:keydown.enter.prevent="preventEnterButton" 
                  :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="value => value.replace(/\$\s?|(,*)/g, '')" 
                  v-decorator="['pendapatan_lain',{ 
                    initialValue: view_data.pendapatan_lain,
                    rules: [{ required: true }] 
                  },]" 
                  :disabled="mode_view"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="Beban Lainnya">
                <a-input-number type="number" class="m-width-full m-text-align-right"
                  v-on:keydown.enter.prevent="preventEnterButton" 
                  :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="value => value.replace(/\$\s?|(,*)/g, '')" 
                  v-decorator="['beban_lain',{ 
                    initialValue: view_data.beban_lain,
                    rules: [{ required: true }] 
                  },]" 
                  :disabled="mode_view"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="Pendapatan / Biaya Non Usaha Bersih">
                <a-input-number type="number" class="m-width-full m-text-align-right"
                  v-on:keydown.enter.prevent="preventEnterButton" 
                  :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="value => value.replace(/\$\s?|(,*)/g, '')" 
                  v-decorator="['biaya_non_usaha',{ 
                    initialValue: view_data.biaya_non_usaha,
                    rules: [{ required: true }] 
                  },]" 
                  :disabled="mode_view"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="Biaya Pajak">
                <a-input-number type="number" class="m-width-full m-text-align-right"
                  v-on:keydown.enter.prevent="preventEnterButton" 
                  :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="value => value.replace(/\$\s?|(,*)/g, '')" 
                  v-decorator="['biaya_pajak',{ 
                    initialValue: view_data.biaya_pajak,
                    rules: [{ required: true }] 
                  },]" 
                  :disabled="mode_view"
                />
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item label="Description">
                <a-textarea
                :rows="4"
                v-decorator="['description', {
                  initialValue: view_data.description,
                }]"
                allow-clear 
                :disabled="mode_view"
                />
              </a-form-item>
            </a-col>
      
          </a-row>
          <a-button-group class="width-full">
            <a-button v-if="!mode_view" :loading="loading_save" class="margin-top" block type="primary" html-type="submit" ref="savetax" @click="onSubmitCreate"><b>Save</b></a-button>
          </a-button-group>
        </a-form>
      </a-modal>

      <a-modal :visible="modal_pipeline" @cancel="modalPipelineOnClose" :footer="null" :maskClosable="false" width="70%">
        <span slot="title"> <a-icon type="plus" /> Choose {{view.type}}</span>
        
        <a-table 
        size="small"
        rowKey="id"
        :columns="columns_pipeline" 
        :data-source="data_table_pipeline"
        :loading="loading_pipeline"
        :pagination="false"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        bordered>
          <template slot="pipeline_no" slot-scope="text, item">
            {{ item.nomor }}
          </template>
          <template slot="definitions" slot-scope="text, item">
            {{ item.definitions }}
          </template>
          <template slot="nilai_proyek" slot-scope="text, item">
            {{ customFormatCurrency('IDR', item.nilai_proyek) }}
          </template>
          <template slot="tlc_create" slot-scope="text, item">
            {{ item.tlc_create }}
          </template>
          <template slot="status" slot-scope="text, item">
            {{ item.status }}
          </template>
          <template slot="progress" slot-scope="text, item">
            {{ item.progress+" %" }}
          </template>
        </a-table>
      </a-modal>

      <a-modal :visible="modal_simulation" @cancel="modalSimulationOnClose" :footer="null" :maskClosable="false" width="60%">
        <span slot="title"> <a-icon type="plus" /> Choose Pipeline Simulation</span>
        
        <a-table 
        size="small"
        rowKey="id"
        :columns="columns_pipeline" 
        :data-source="data_table_simulation"
        :loading="loading_simulation"
        :pagination="false"
        :row-selection="{ selectedRowKeys: selectedRowSimulationKeys, onChange: onSelectSimulationChange }"
        bordered>
          <template slot="pipeline_no" slot-scope="text, item">
            {{ item.nomor }}
          </template>
          <template slot="definitions" slot-scope="text, item">
            {{ item.definitions }}
          </template>
          <template slot="nilai_proyek" slot-scope="text, item">
            {{ customFormatCurrency('IDR', item.nilai_proyek) }}
          </template>
          <template slot="tlc_create" slot-scope="text, item">
            {{ item.tlc_create }}
          </template>
          <template slot="status" slot-scope="text, item">
            {{ item.status }}
          </template>
          <template slot="progress" slot-scope="text, item">
            {{ item.progress+" %" }}
          </template>
        </a-table>
        <div>
          <div class="footer-card">
            <a-button type="primary" @click="calculateSimulation()">Calculate</a-button>
          </div>
        </div>
      </a-modal>
    </div>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  import moment from "moment";
  import axios from "axios";
  import Status from "@/components/Status.vue";
  import CurrencyFormat from "@/mixins/CurrencyFormat";
  import _ from "lodash";
  import Detail from "./detail.vue";
  
  export default {
    name: "klaimCcTiket",
    props: ["prnMenu"],
    mixins: [CurrencyFormat],
    components: {
      Detail,
    },
    data() {
      const columns = [
        {
          title: "Component",
          key: "component",
          // width: 250,
          align: "left",
          scopedSlots: { customRender: "component" },
        },
        {
          title: "Value",
          key: "value",
          // width: 250,
          align: "right",
          scopedSlots: { customRender: "value" },
        },
        {
          title: "% Revenue",
          key: "revenue",
          // width: 250,
          align: "right",
          scopedSlots: { customRender: "revenue" },
        }
      ];

      const columns_pipeline = [
        {
          title: "No.",
          key: "pipeline_no",
          // width: 250,
          align: "left",
          scopedSlots: { customRender: "pipeline_no" },
        },
        {
          title: "Description",
          key: "definitions",
          // width: 250,
          align: "left",
          scopedSlots: { customRender: "definitions" },
        },
        {
          title: "Value",
          key: "nilai_proyek",
          // width: 250,
          align: "right",
          scopedSlots: { customRender: "nilai_proyek" },
        },
        {
          title: "TLC Create",
          key: "tlc_create",
          // width: 250,
          align: "center",
          scopedSlots: { customRender: "tlc_create" },
        },
        {
          title: "Status",
          key: "status",
          // width: 250,
          align: "center",
          scopedSlots: { customRender: "status" },
        },
        {
          title: "Progress",
          key: "progress",
          // width: 250,
          align: "center",
          scopedSlots: { customRender: "progress" },
        }
      ]

      return {
        loading: false,
        dataList: [],
        listDirector: [],
        searchDate: null,
        search: "",
        status: undefined,
        director: undefined,
        triggerSearch: false,
        modal_create: false,
        loading_save: false,
        loading_view: false,
        yearOpen: false,
        version:[],
        selected: {
          year: null,
          type: null,
          version: null
        },
        view: {
          year: null,
          type: null,
          version: null
        },
        loading_detail: false,
        data_detail: [],
        data_type: [],
        activeKey: {
          header: 1
        },
        data_header: {
          cashflow_value: 0,
          est_contract_value: 0,
          total_allocated: 0,
          total_plafon: 0, 
          total_realization: 0,
          realization_value: 0
        },
        typeList: [
            {
                "label": "Pipeline",
                "value": "pipeline"
            }
        ],
        year: [],
        version: [],
        columns,
        loading: {
          page: false,
          table: false,
        },
        data_table: [],
        expandedRowKeys: [],
        ebt: {
          planning: 0,
          actual: 0,
          realization: 0,
          pa_value: 0
        },
        depreciation: {
          planning: 0,
          actual: 0,
          realization: 0
        },
        overhead: {
          planning: 0,
          actual: 0,
          realization: 0
        },
        target_value: {
          planning: 0,
          actual: 0,
          realization: 0
        },
        isBillion: false,
        loading_pipeline: false,
        modal_pipeline: false,
        columns_pipeline,
        data_table_pipeline: [],
        selectedRowKeys: [],
        pipelineStatus: {},
        enabledSimulation: true,
        modal_simulation: false,
        data_table_simulation: [],
        selectedRowSimulationKeys: [],
        loading_simulation: false,
        data_simulation: [],
        rups_option: [],
        view_data: {
          year: null,
          overhead: null,
          depresiasi: null,
          ebt: null,
          description: null,
          biaya_penjualan: null,
          biaya_admin_umum: null,
          beban_penyusutan: null,
          beban_amortisasi: null,
          beban_modal: null,
          pendapatan_lain: null,
          beban_lain: null,
          biaya_non_usaha: null,
          biaya_pajak: null,
        },
        mode_view: true
      };
    },
    computed: {
      ...mapGetters([
        "getScreen",
        "getAuth",
        "getStatus",
        "getDefaultDateFormat",
        "getStandartFormatDate",
      ]),

      searching() {
        var self = this;
        let outputData = this.dataList;
  
        if (this.search) {
          outputData = _.filter(
            outputData,
            (obj) =>
              obj.searchQ.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
          );
        }
  
        if (this.searchDate) {
          let filter = moment(this.searchDate).format(this.getStandartFormatDate);
          outputData = _.filter(outputData, { tgl_buat: filter });
        }
  
        if (this.director) {
          outputData = outputData.filter(
            (obj) =>
              obj.tlc_bod &&
              obj.tlc_bod.toLowerCase().indexOf(self.director.toLowerCase()) >= 0
          );
        }
  
        if (this.status) {
          outputData = _.filter(
            outputData,
            (obj) =>
              obj.status && obj.status.toLowerCase().indexOf(self.status) >= 0
          );
        }
  
        return outputData;
      },
      getManifestLink() {
        if (localStorage.getItem("nvpn") === "/FinancialControl") {
          return "SpclKlaimCCManifestFin";
        }
      },

      isEnabled() {
        if (this.data_table && this.data_table.length > 0) {
          return false
        }

        return true
      },

      calculateEbtValue(){
        const value = (this.target_value.planning * this.ebt.planning) / 100;
        return value
      },

      show_choose_pipeline(){
        return this.getAuth.nama_bidang[0] == "Financial Control";
      }

    },
    watch: {
      selected: {
        handler(val) {
          const { year, type, version } = val

          if (year && type && version) {
            this.enabledSimulation = false
            this.fetchData()
          }else {
            this.enabledSimulation = true
          }
        },
        deep: true
      }
    },

    beforeCreate() {
      this.form_create = this.$form.createForm(this);
    },

    created() {
      this.fetchData();
    },
    mounted() {
      Event.$on("callbackTab", this.clickTabed); 
      
    },
    beforeDestroy() {
      Event.$off("callbackTab", this.clickTabed);
    },
    methods: {
      moment,
      getAllKeys(items = []) {
        return items.reduce((keys, item) => {
          keys.push(item.key)

          if (item.children && item.children.length) {
            keys.push(...this.getAllKeys(item.children))
          }

          return keys
        }, [])
      },
      clearViewData() {
        this.view_data.year = null;
        this.view_data.overhead = null;
        this.view_data.depresiasi = null;
        this.view_data.ebt = null;
        this.view_data.description = null;
        this.view_data.biaya_penjualan = null;
        this.view_data.biaya_admin_umum = null;
        this.view_data.beban_penyusutan = null;
        this.view_data.beban_amortisasi = null;
        this.view_data.beban_modal = null;
        this.view_data.pendapatan_lain = null;
        this.view_data.beban_lain = null;
        this.view_data.biaya_non_usaha = null;
        this.view_data.biaya_pajak = null;
      },
      async fetchData() {
        try {
          this.loading = true
            const res = await axios({
                method: "get",
                url: this.$serviceUrl + "annual_target",
                auth: {
                    username: this.getAuth.username,
                    password: this.getAuth.password,
                },
                headers: {
                    "X-API-KEY": this.getAuth.apikey,
                },
                params: {
                  type: this.selected.type,
                  year: this.selected.year,
                  annual_target: this.selected.version
                }
            })

            if(res){
              this.dataList = res.data.data ? res.data.data : []
              this.typeList = res.data.opt_type
              this.year = res.data.opt_year
              this.version = res.data.opt_annual_target
              this.data_table = []
              this.expandedRowKeys = []
              this.data_table = res.data.detil
              this.expandedRowKeys = this.getAllKeys(this.data_table)
              this.rups_option = res.data.opt_year_rups
              
              this.ebt.planning = Number(res.data.ebt ? res.data.ebt : 0)
              this.ebt.actual = Number(res.data.pa_ebt_percent? res.data.pa_ebt_percent : 0)
              this.ebt.pa_value = Number(res.data.pa_ebt_value? res.data.pa_ebt_value : 0)

              this.depreciation.planning = Number(res.data.depresiasi ? res.data.depresiasi : 0)
              this.depreciation.actual = Number(res.data.pa_depresiasi_value ? res.data.pa_depresiasi_value : 0)

              this.overhead.planning = Number(res.data.overhead ? res.data.overhead : 0)
              this.overhead.actual = Number(res.data.pa_overhead_value ? res.data.pa_overhead_value : 0)

              this.target_value.planning = Number(res.data.project_value ? res.data.project_value : 0)
              this.target_value.actual = Number(res.data.pa_project_value ? res.data.pa_project_value : 0)
            }
            this.loading = false
        } catch (error) {
            console.log(error);
            this.loading = false
        }
    },

    onExpand(expanded, record) {
      if (expanded) {
        this.expandedRowKeys.push(record.key)
      } else {
        this.expandedRowKeys =
          this.expandedRowKeys.filter(
            key => key !== record.key
          )
      }
    },
      clickTabed(val) {
        this.search = "";
        this.searchDate = undefined;
        this.director = undefined;
        this.status = undefined;
        if (val == "draft") {
          this.triggerSearch = true;
        } else {
          this.triggerSearch = false;
        }
      },

      showModalCreate(){
        this.mode_view = false;
        this.clearViewData();
        this.modal_create = true
      },
      async viewModalAnnualTarget(){
        if (!this.selected.version) {
          this.displayMessageValue("basic-warning", "Please select version");
          return;
        }
        this.mode_view = true;
        this.loading_view = true;
        try {
          const res = await axios({
            method: "get",
            url: this.$serviceUrl + "annual_target/view",
            auth: {
                username: this.getAuth.username,
                password: this.getAuth.password,
            },
            headers: {
                "X-API-KEY": this.getAuth.apikey,
            },
            params: {
              id_annual_project: this.selected.version
            }
          })
          if(res){
            if (res.data.status) {
              const annual_target = res.data.data[0];
              this.view_data.year = annual_target.year;
              this.view_data.overhead = annual_target.overhead;
              this.view_data.depresiasi = annual_target.depresiasi;
              this.view_data.ebt = annual_target.ebt;
              this.view_data.description = annual_target.remark;
              this.view_data.biaya_penjualan = annual_target.biaya_penjualan;
              this.view_data.biaya_admin_umum = annual_target.biaya_admin_umum;
              this.view_data.beban_penyusutan = annual_target.beban_penyusutan;
              this.view_data.beban_amortisasi = annual_target.beban_amortisasi;
              this.view_data.beban_modal = annual_target.beban_modal;
              this.view_data.pendapatan_lain = annual_target.pendapatan_lain;
              this.view_data.beban_lain = annual_target.beban_lain;
              this.view_data.biaya_non_usaha = annual_target.biaya_non_usaha;
              this.view_data.biaya_pajak = annual_target.biaya_pajak;
              this.modal_create = true;
            } else {
              this.displayMessageValue("error-other", res.data.message);  
            }
          }
        } catch (err) {
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error", responses);
        }
        this.loading_view = false;
      },
      modalOnClose(){
        this.modal_create = false
        this.form_create.resetFields()
      },

      onSubmitCreate(){
        this.loading_save = true
        this.form_create.validateFields( async (err, values) => {
          if (err) {
            this.loading_save = false
            this.displayMessage("form-warning");
            return;
          }

          let formData = new FormData()
          formData.append('overhead', values.overhead)
          formData.append('depresiasi', values.depresiasi)
          formData.append('ebt', values.ebt)
          formData.append('remark', values.description)
          formData.append('year',  values.year)
          formData.append('biaya_penjualan',  values.biaya_penjualan)
          formData.append('biaya_admin_umum',  values.biaya_admin_umum)
          formData.append('beban_penyusutan',  values.beban_penyusutan)
          formData.append('beban_amortisasi',  values.beban_amortisasi)
          formData.append('beban_modal',  values.beban_modal)
          formData.append('pendapatan_lain',  values.pendapatan_lain)
          formData.append('beban_lain',  values.beban_lain)
          formData.append('biaya_non_usaha',  values.biaya_non_usaha)
          formData.append('biaya_pajak',  values.biaya_pajak)

          try {
            const res = await axios({
              method: "POST",
              url: this.$serviceUrl + "annual_target",
              auth: {
                  username: this.getAuth.username,
                  password: this.getAuth.password,
              },
              headers: {
                  "X-API-KEY": this.getAuth.apikey,
              },
              data: formData
            })
            this.loading_save = false
            this.modalOnClose()
            this.fetchData()
            this.displayMessage("success-save");
            this.form_create.resetFields()
          } catch (error) {
            this.loading_save = false
            console.log(error);
          }
        })
      },

      handleOpenChange(status) {
        this.yearOpen = status
      },

      handleYearChange(value) {
        this.form_create.setFieldsValue({
          year: value
        })

        this.yearOpen = false
      },

      onChangeEbt(val){
        if(val > 100){
          this.form_create.setFieldsValue({
            ebt: 100
          })
        }else if(val < 0){
          this.form_create.setFieldsValue({
            ebt: 0
          })
        }
      },

      refreshData(){
        this.fetchData()
      },

      filterOption(input, option) {
        return (
          option.componentOptions.children[0].text
            .toLowerCase()
            .indexOf(input.toLowerCase()) >= 0
        );
      },

      changeType(val){
        const select = this.typeList.find((e) => e.value == val)
        this.view.type = select.label
        // this.fetchData()

      },

      changeYear(val){
        this.view.year = val
        // this.fetchData()

      },

      changeVersion(val){
        const select = this.version.find((e) => e.value == val)
        this.view.version = select.label
        // this.fetchData()

      },

      rowClassName(record) {
        if (record.component == 'Ebitda' || record.component == 'Ebt') {
          return 'summary-row'
        }
        return ''
      },

      realization(planning, actual) {
        const planning_value = Number(planning || 0)
        const actual_value = Number(actual || 0)

        if (!planning_value) {
          return 0
        }
        const total = Number(((actual_value / planning_value) * 100).toFixed(2))
        return total
      },
      
      calculateMargin(planning, actual, type='percentage') {
        const planning_value = Number(planning || 0)
        const actual_value = Number(actual || 0)

        if (!planning_value) {
          return '-'
        }

        const diff = Number(actual_value - planning_value).toFixed(2)

        if (diff > 0) {
          if(type=='percentage'){
            return `+${diff}%`
          }else return `+${this.formatCurrency('IDR', diff)}`
        }
        
        if (diff < 0) {
          if(type=='percentage'){
            return `${diff}%`
          }else return `${this.formatCurrency('IDR', diff)}`
        }

        return '100%'
      },

      tableColumns(type){
        if(type == 'pipeline'){
          const columns = [
          {
              title: "No. Pipline",
              key: "pipeline_no",
              // width: 250,
              align: "left",
              scopedSlots: { customRender: "pipeline_no" },
            },
            {
              title: "Description",
              key: "definitions",
              // width: 250,
              align: "left",
              scopedSlots: { customRender: "definitions" },
            },
            {
              title: "Value",
              key: "nilai_proyek",
              // width: 250,
              align: "right",
              scopedSlots: { customRender: "nilai_proyek" },
            },
            {
              title: "TLC Create",
              key: "tlc_create",
              // width: 250,
              align: "center",
              scopedSlots: { customRender: "tlc_create" },
            },
            {
              title: "Status",
              key: "status",
              // width: 250,
              align: "center",
              scopedSlots: { customRender: "status" },
            },
            {
              title: "Progress",
              key: "progress",
              // width: 250,
              align: "center",
              scopedSlots: { customRender: "progress" },
            }
          ];
          return columns
        } else if(type == 'budget'){
          const columns = [
          {
              title: "No. Budget",
              key: "pipeline_no",
              // width: 250,
              align: "left",
              scopedSlots: { customRender: "pipeline_no" },
            },
            {
              title: "Description",
              key: "definitions",
              // width: 250,
              align: "left",
              scopedSlots: { customRender: "definitions" },
            },
            {
              title: "Value",
              key: "nilai_proyek",
              // width: 250,
              align: "right",
              scopedSlots: { customRender: "nilai_proyek" },
            },
            {
              title: "TLC Create",
              key: "tlc_create",
              // width: 250,
              align: "center",
              scopedSlots: { customRender: "tlc_create" },
            }
          ];
          return columns
        }
      },

      async fetchListPipeline(){
        this.columns_pipeline = this.tableColumns(this.selected.type)
        try {
          this.loading_pipeline = true
          const res = await axios({
            method: "get",
            url: this.$serviceUrl + `annual_target/${this.selected.type}`,
            auth: {
                username: this.getAuth.username,
                password: this.getAuth.password,
            },
            headers: {
                "X-API-KEY": this.getAuth.apikey,
            },
            params: {
              year: this.selected.year
            }
          })

          if(res){
            if(this.selected.type == 'pipeline'){
              this.data_table_pipeline = res.data.pipeline
            }else if(this.selected.type == 'budget'){
              this.data_table_pipeline = res.data.budget
            }
            
            this.selectedRowKeys = this.data_table_pipeline
            .filter(item => item.used == "1")
            .map(item => item.id)
          }
          this.loading_pipeline = false
          this.modal_pipeline = true
        } catch (error) {
          this.loading_pipeline = false
          console.log(error);
          
        }
      },

      modalPipelineOnClose(){
        this.modal_pipeline = false
      },

      async onSelectChange(selectedRowKeys){
        this.selectedRowKeys = selectedRowKeys
        try {
          this.data_table_pipeline.forEach(item => {
            this.$set(
              this.pipelineStatus,
              item.id,
              selectedRowKeys.includes(item.id) ? 1 : 0
            )
          })
          const payload = new FormData()

          let index = 0
          Object.entries(this.pipelineStatus).forEach(([id, status]) => {
            payload.append(`${this.selected.type}_id[${index}]`, id)
            payload.append(`status[${id}]`, status)

            index++
          })
          
          const res = await axios({
            method: "POST",
            url: this.$serviceUrl + `annual_target/${this.selected.type}`,
            auth: {
                username: this.getAuth.username,
                password: this.getAuth.password,
            },
            headers: {
                "X-API-KEY": this.getAuth.apikey,
            },
            data: payload
          })
          if(res){
            this.fetchData()
          }
        } catch (error) {
          console.log(error);
        }
      },

      async showModalSimulation(){
        try {
          this.columns_pipeline = this.tableColumns(this.selected.type)
          this.loading_simulation = true
          const res = await axios({
            method: "get",
            url: this.$serviceUrl + `annual_target/${this.selected.type}`,
            auth: {
                username: this.getAuth.username,
                password: this.getAuth.password,
            },
            headers: {
                "X-API-KEY": this.getAuth.apikey,
            },
            params: {
              year: this.selected.year
            }
          })

          if(res){
            if(this.selected.type == 'pipeline'){
              this.data_table_simulation = res.data.pipeline
            }else if(this.selected.type == 'budget'){
              this.data_table_simulation = res.data.budget
            }

            this.selectedRowSimulationKeys = this.data_table_simulation
            .filter(item => item.used == "1")
            .map(item => item.id)
          }
          this.loading_simulation = false
          this.modal_simulation = true
        } catch (error) {
          this.loading_simulation = false
          console.log(error);
        }
      },

      modalSimulationOnClose(){
        this.modal_simulation = false
      },

      onSelectSimulationChange(keys){
        this.selectedRowSimulationKeys = keys
      },

      calculateSimulation(){
        const filterData = this.data_table_simulation.filter((dat) => this.selectedRowSimulationKeys.includes(dat.id))
        const array_key = ['nilai_proyek', 'pajak_proyek', 'komisi', 'biaya_proyek', 'overhead', 'ebitda', 'beban_bunga', 'depresiasi', 'ebt'];
        
        let array_object = Array()
        let value_project = 0
        let overhead = 0
        let depreciation = 0
        let ebt = 0
        
        array_key.forEach((key, i) => {
          let childrens = Array()
          let total_val = 0;
          let total_revenue = 0;
          let child_count = 0;

          filterData.forEach((dat, j) => {
            total_val += Number(dat[key] || 0)
            total_revenue += Number(dat[`${key}_revenue`] || 0)

            if(key == 'nilai_proyek') value_project += Number(dat[key] || 0)
            
            const children = {
              key: i+'_'+dat.id,
              nomor: dat.nomor,
              definitions: dat.definitions,
              revenue: dat.nilai_proyek_revenue,
              value: dat.nilai_proyek
            }
            childrens.push(children)
            child_count+=1;
          })

          total_revenue = total_revenue/child_count
          let payload = {
            component: key.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '),
            value: total_val,
            revenue: this.formatDecimal(total_revenue),
            key: i
          }
          if(key !== 'ebitda' && key !== 'ebt'){
            payload.children = childrens
          }
          array_object.push(payload)

          if(key == 'overhead') overhead = total_val
          else if(key == 'depresiasi') depreciation = total_val
          else if(key == 'ebt') ebt = total_revenue
        });

        const final_data = {
          depresiasi: this.depreciation.planning,
          overhead: this.overhead.planning,
          ebt: this.ebt.planning,
          pa_depresiasi: depreciation,
          pa_overhead: overhead,
          pa_ebt: ebt,
          detail: array_object
        }

        this.overhead.actual = overhead
        this.depreciation.actual = depreciation
        this.ebt.actual = this.formatDecimal(ebt)
        this.data_table = array_object
        this.modal_simulation = false
        this.$message.success(
          `Data simulasi berhasil dibuat`
        )
      },

      formatDecimal(number){
        return Number(number.toFixed(2))
      }
    },

    

  };
  </script>
  
<style lang="less">
.c_annualPlafon {
  .ant-card-head-title{
    margin-right: 0px!important;
  }
  .cmain-title{
    max-width: 50%;
    text-wrap: auto;
    word-break: normal;
  }
  .cbtn-create {
    i {color: #fff;}
    path{color: #fff;}
    span {color: #fff;}
  }
  .hdr_plfn{
    .ant-table-title{
      padding-bottom: 0px;
    }
  }
  .option_plfn{
    td{
    padding: 0px;
    }
  }
  .hdr_plfn_selection{
    padding: 16px;
    cursor: pointer;
  }
  .hdr_plfn_selection.isfocused  {
    background-color: fade(@color-secondary, 5%);
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.25), 0 2px 8px rgba(0, 0, 0, 0.25), inset 0px 0px 0px 1px rgba(255, 255, 255, 0.1);
    border-left-style: solid;
    border-left-color: @color-secondary;
  }
  .row-ecv{
    .ant-input-number{
      justify-content: flex-end;
    }
    .ant-input-number-input{
      text-align: right;
      display: block;
    }
  }
  .row_h{
    margin-right: 11px;
  }

  .ngabango{
    background-color: fade(@color-primary, 35%);
  }
}

.cAnnualfromcreate{
  .ant-input-number-input{
    text-align: right;
    padding-right: 25px;
  }
}

.plafonformtables{
  // .ant-table-row {
    .ant-table-thead {
      background: #c1c1c1;
      font-weight: bolder;
    }
    tr:first-child {
      td:hover {
        background: #00ca8e;
      }
    }
    td:nth-child(4){
      background: #c1c1c1;
    }

    .ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected):not(.cSUMMARY) > td, 
    .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected):not(.cSUMMARY) > td, 
    .ant-table-thead > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected):not(.cSUMMARY) > td, 
    .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected):not(.cSUMMARY) > td {
      background: none;
    }

    .ant-table-thead > tr.cSUMMARY.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td, 
    .ant-table-tbody > tr.cSUMMARY.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td, 
    .ant-table-thead > tr.cSUMMARY:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td, 
    .ant-table-tbody > tr.cSUMMARY:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
      background: #c1c1c1;
    }
  // }
}

.overvalueRow{
  background-color: fade(@color-primary, 35%);
}

.custom-card .ant-card-body {
  padding: 0px !important;
}

.custom-table .ant-table {
  border: none !important;
}

.custom-table .ant-table-container {
  border-inline-start: none !important;
  border-top: none !important;
}

.custom-table .ant-table-bordered > .ant-table-container {
  border: none !important;
}

.single-parent {
  text-transform: uppercase;
  font-weight: bold;
}

.summary-row td {
  background: #f3e8e8 !important;
  font-weight: bold;
}

.chart-container{
  display: flex;
  align-items: center;
  justify-content: center;
}

.progress-big-text .ant-progress-text {
  font-size: 22px !important;
  font-weight: bold;
}

.footer-card {
  margin-top: 10px;
  padding-top: 10px;
  display: flex;
  justify-content: flex-end;
}

</style>
  